export default __webpack_public_path__ + "static/media/header.1c64bff7.svg";